










































































import type { PropType } from "vue"
import type { stadium_business } from "@/@types/stadium/stadium"
import { Vue } from "vue-property-decorator"

export default Vue.extend({
  name: "StadiumBusinessForm",
  props: {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
    addr    : { type: String, default: "" },
    form    : { type: Object as PropType<stadium_business> }
  },
  data() {
    return {
      area : [] as string[],
      rules: {
        enterprise_name        : { required: true, message: "营业执照名称不能为空", trigger: "blur" },
        credit_code            : { required: true, message: "统一社会信用代码不能为空", trigger: "blur" },
        legal_representative   : { required: true, message: "法人代表不能为空", trigger: "blur" },
        legal_phone            : { required: true, message: "电话不能为空", trigger: "blur" },
        principal_name         : { required: true, message: "经营负责人不能为空", trigger: "blur" },
        principal_phone        : { required: true, message: "电话不能为空", trigger: "blur" },
        publicity_material_addr: { required: true, message: "收件地址不能为空", trigger: "blur" },
      },
    }
  },
  methods: {
    change_address(e: any) {
      if (e.target.checked) {
        this.form.publicity_material_addr = this.addr
      }
    },
    submit() {
      const form = this.$refs.form as any
      const params = this.$deep_copy(this.form)
      params.estimate_id = this.id
      form.validate((valid: boolean) => {
        if (valid) this.$emit("save", params)
      })
    },
    check(): boolean {
      let checked = false
      const form = this.$refs.form as any
      form.validate((valid: boolean) => {
        checked = valid
      })
      return checked
    },
  }
})
